import React from 'react';

import PolicyResult from 'components/atoms/policy_result';

const PolicyAnalysis: React.FC = () => (
  <PolicyResult
    variant="analysis"
    icon={<i className="material-icons">hourglass_empty</i>}
    title="Apólice de seguros em análise por parte da seguradora"
    source="Tela Apólice em Análise ConlicitaSeg Only"
  >
    Você será notificado assim que a seguradora finalizar a análise.
  </PolicyResult>
);

export default PolicyAnalysis;
